import React, {useContext} from 'react';

import Ad from '~/src/components/ad/Ad';
import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';

import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {getAdUnitName} from '~/src/utilities/helpers/ad';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {classNames} from '~/src/utilities/helpers/css';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './TeaserLayoutRelatedContent.module.scss';
import i18nStrings from './TeaserLayoutRelatedContent.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const TeaserLayoutRelatedContent = ({showTitle, colorScheme, children}: TeaserLayoutProps) => {
    const {siteArea} = useContext(SettingsContext);
    const headerClassNames = classNames(css, 'titleHeader', siteArea, colorScheme);
    const teaserClassNames = classNames(css, 'teasers', siteArea, colorScheme);

    const title = getTranslation(siteArea === SiteArea.VIDEO ? 'relatedVideos' : 'relatedArticles');

    const elements = React.Children.toArray(children);

    for (let i = Math.floor(elements.length / 4); i > 0; i--) {
        elements.splice(i * 4, 0, <Ad className={css.ad} adUnitName={getAdUnitName('inside-full-recommender', getNextCounter('inside-full-recommender'))} />);
    }

    return (
        <React.Fragment>
            {showTitle && (
                <div className={headerClassNames}>
                    <h1 className={css.title}>{title}</h1>
                </div>
            )}

            <div className={teaserClassNames}>{elements}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutRelatedContent;
